import { gql } from "@apollo/client";

export const STATE_TRANSITION_QUERY = gql`
  query stateTransitionData($documentId: Int!) {
    stateTransitionData(documentId: $documentId) {
      documentId
      states {
        transitionId
        stateName
        userName
        transitionMoment
        freeTxt
        stateTransitionReasons
      }
    }
  }
`;

export const DOCUMENT_STATE_REASONS_QUERY = gql`
  query documentStateReasons($documentStateId: Int!, $documentTypeId: Int!) {
    documentStateReasons(documentStateId: $documentStateId, documentTypeId: $documentTypeId) {
      documentStateXReasonId
      reasonId
      description
    }
  }
`;
